const MINUTES_PER_DAY = 24 * 60;

export function timeToMinutes(value) {
  const [hours, minutes] = value.split(':').map(Number);
  return hours * 60 + minutes;
}

export function minutesToTime(value) {
  const safe = ((Math.round(value) % MINUTES_PER_DAY) + MINUTES_PER_DAY) % MINUTES_PER_DAY;
  return `${String(Math.floor(safe / 60)).padStart(2, '0')}:${String(safe % 60).padStart(2, '0')}`;
}

export function windowLengthHours(start, end) {
  const a = timeToMinutes(start); const b = timeToMinutes(end);
  return Math.round((((b - a + MINUTES_PER_DAY) % MINUTES_PER_DAY) / 60) * 10) / 10;
}

export function isInsideEatingWindow(time, start, end) {
  const current = timeToMinutes(time); const a = timeToMinutes(start); const b = timeToMinutes(end);
  return a <= b ? current >= a && current < b : current >= a || current < b;
}

/** Old-app behaviour: open after the first morning session, close two hours after the last. */
export function deriveEatingWindow({ fallback, sessions = [] }) {
  const timed = sessions
    .filter((session) => session?.start && session?.end)
    .map((session) => ({ start: timeToMinutes(session.start), end: timeToMinutes(session.end) }))
    .sort((a, b) => a.start - b.start);
  if (timed.length === 0) return { ...fallback, derived: false };
  const baseEnd = timeToMinutes(fallback.end);
  const first = timed[0]; const last = timed.at(-1);
  const start = first.start < 11 * 60 ? Math.ceil(first.end / 15) * 15 : timeToMinutes(fallback.start);
  const end = Math.min(22 * 60, Math.ceil(Math.max(baseEnd, last.end + 120) / 15) * 15);
  return { start: minutesToTime(start), end: minutesToTime(Math.max(start + 60, end)), derived: true };
}

export function staplesScore(item, nowMs = Date.now()) {
  const uses = Number(item.useCount) || 0;
  if (!uses) return item.pinned ? 1 : 0;
  const ageDays = Math.max(0, (nowMs - new Date(item.lastUsedAt ?? 0).getTime()) / 86_400_000);
  return uses * Math.pow(0.5, ageDays / 14) + (item.pinned ? 1000 : 0);
}

